import type { CSSProperties } from 'react';

export const toPngDataUrl = (
  imageUrl: string,
  options?: {
    backgroundColor?: CSSProperties['backgroundColor'];
    width?: number;
    height?: number;
  },
): Promise<string> =>
  new Promise((resolve, reject) => {
    const img = document.createElement('img');
    img.onerror = reject;
    img.onload = () => {
      document.body.appendChild(img);
      const canvas = document.createElement('canvas');
      const ratio = img.clientWidth / img.clientHeight || 1;
      document.body.removeChild(img);
      if (options?.width || options?.height) {
        canvas.width = options.width ?? options.height! * ratio;
        canvas.height = options.height ?? options.width! / ratio;
      } else {
        canvas.width = img.clientWidth;
        canvas.height = img.clientHeight;
      }

      const ctx = canvas.getContext('2d')!;

      if (options?.backgroundColor) {
        ctx.fillStyle = options.backgroundColor;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      }
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      try {
        resolve(canvas.toDataURL('image/png'));
      } catch (e) {
        reject(e);
      }
    };
    img.src = imageUrl;
  });
